import { render, staticRenderFns } from "./WebProfileCard.vue?vue&type=template&id=6f62915b&scoped=true"
import script from "./WebProfileCard.vue?vue&type=script&lang=js"
export * from "./WebProfileCard.vue?vue&type=script&lang=js"
import style0 from "./WebProfileCard.vue?vue&type=style&index=0&id=6f62915b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f62915b",
  null
  
)

export default component.exports